{
  "form": {
    "title": "Відновлення паролю",
    "subtitle": "Вам потрібно змінити пароль.",

    "password": {
      "label": "Пароль",
      "placeholder": "Створіть пароль",
      "message": "Мінімум 8 символів, одна велика і одна мала літера"
    },
    "confirmPassword": {
      "label": "Повторити пароль",
      "placeholder": "Ще раз для підтвердження",
      "message": "Мінімум 8 символів, одна велика і одна мала літера"
    },
    "submit": {
      "label": "Підтвердити",
      "loading": "Завантаження"
    }
  },

  "success-message": "Ваш акаунт було успішно оновлено",
  "unknown-error": "Не вдається оновити пароль. Будь ласка, спробуйте пізніше."
}
